function isEmpty(value) {
    return value === null
        || value === undefined
        || value === ""
        || (
            Array.isArray(value)
            && value?.length == 0
        )
        || (
            Object.getPrototypeOf(value ?? {}) === Object.prototype
            && Object.keys(value ?? {})?.length == 0
        )
        ;
}

function required(value) {
    return isEmpty(value)
        ? "Este campo é obrigatório."
        : true;
}

function requiredIf(value, condition) {
    if (!condition) {
        return true;
    }

    return required(value);
}

function requiredIfAny(value, conditions = []) {
    return requiredIf(value, conditions.some(Boolean));
}

function requiredIfAll(value, conditions = []) {
    return requiredIf(value, conditions.every(Boolean));
}

function valueMustBeEqual(value, comparison, strict = false) {
    const isEqual = strict
        ? value === comparison
        : value == comparison;

    return isEqual
        ? true
        : `O valor deste campo tem de ser '${comparison}', atualmente é: '${value}'.`;
}

function valueMustBeDifferent(value, comparison, strict = false) {
    const isDifferent = strict
        ? value !== comparison
        : value != comparison;

    return isDifferent
        ? true
        : `O valor deste campo não pode ser '${value}'.`;
}

function valueMustBelongTo(value, allowedValues = [], strict = false) {
    if (isEmpty(value)) {
        return true;
    }

    const belongs = allowedValues.some((allowed) => {
        return strict
            ? value === allowed
            : value == allowed;
    });

    return belongs
        ? true
        : `Valor '${value}' inválido para este campo. Valores permitidos: ${allowedValues.join(", ")}.`;
}

function valueCannotBelongTo(value, forbiddenValues = [], strict = false) {
    if (isEmpty(value)) {
        return true;
    }

    const isForbidden = forbiddenValues.some((forbidden) => {
        return strict
            ? value === forbidden
            : value == forbidden;
    });

    return isForbidden
        ? `Valor '${value}' inválido para este campo. Valores proibidos: ${forbiddenValues.join(", ")}.`
        : true;
}

function intersectionValidator(
    valuesToEvaluate,
    valuesToCompare,
) {
    
    if(!Array.isArray(valuesToEvaluate)) {
        throw new TypeError(`Argument 'valuesToEvaluate' must be an array, got '${typeof valuesToEvaluate}' instead!`);
    }
    if(!Array.isArray(valuesToCompare)){
        throw new TypeError(`Argument 'valuesToCompare' must be an array, got '${typeof valuesToCompare}' instead!`);
    }
}

function cannotIntersect(
    valuesToEvaluate, 
    valuesToCompare = [], 
    valuesLabels = {}, 
    inputLabel = null
) {
    if(isEmpty(valuesToEvaluate)) {
        return true;
    }
    if(isEmpty(valuesToCompare)) {
        return true;
    }
    
    intersectionValidator(valuesToEvaluate, valuesToCompare)

    const needlesSet = new Set(valuesToEvaluate);
    const haystackSet = new Set(valuesToCompare);
    const intersection = needlesSet.intersection(haystackSet);
    const labels = valuesToEvaluate.map((v) => {
        return haystackSet.has(v)
                ? `'${valuesLabels?.[v] ?? v}'`
                : null
    }).filter(Boolean);

    return Array.from(intersection)?.length > 0
            ? `Valores proibidos porque pertencem a ${inputLabel ? `'${inputLabel}'`: 'outro campo'}: ${labels?.join(', ')}.`
            : true;
}

function mustIntersect(valuesToEvaluate, valuesToCompare = [], valuesLabels = {}) {
    if(isEmpty(valuesToEvaluate)) {
        return false;
    }
    if(isEmpty(valuesToCompare)) {
        return false;
    }
    
    intersectionValidator(valuesToEvaluate, valuesToCompare)

    const needlesSet = Set(valuesToEvaluate);
    const haystackSet = Set(valuesToCompare);
    const intersection = needlesSet.intersection(haystackSet);

    const labels = valuesToEvaluate.map((v) => {
        return !haystackSet.has(v)
                ? `'${valuesLabels?.[v] ?? v}'`
                : null
    }).filter(Boolean);

    return Array.from(intersection)?.length == 0
            ? `Faltam valores obrigatórios neste campo: ${labels?.join(', ')}.`
            : true;
}

export default {
    isEmpty, 
    required, 
    requiredIf,
    requiredIfAny,
    requiredIfAll,
    valueMustBeEqual, 
    valueMustBelongTo, 
    valueCannotBelongTo, 
    valueMustBeDifferent,
    cannotIntersect,
    mustIntersect,
}